<template>
    <div class="home">
        <Bar class="hidden-xs-only"></Bar>
        <div class="menuSmall hidden-sm-and-up" ref="getMenuH">
            <div class="imgLimit"><router-link to="/"><img src="../../assets/yylogo.png"></router-link></div>

            <div class="menuBo" @click="open">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <MenuBar v-show="ifOpen"></MenuBar>
    </div>
</template>

<script>
import Bar from './bar.vue'
import MenuBar from './menubar.vue'
import { mapState } from 'vuex'

export default{
    components: {
        Bar,
        MenuBar
    },
    computed:{
      ...mapState({
        ifOpen: state => state.toTab.ifOpen,
        // ifDrop: state => state.toTab.ifDrop
      })
    },
    data(){
        return{
            isOpen: false
        }
    },
    methods:{
        open(){
            this.isOpen = !this.isOpen
            this.$store.commit('toTab/change_ifOpen',this.isOpen)
            // this.$store.commit('toTab/change_ifDrop',false)
        }
    }
}
</script>

<style lang="scss" scoped>
.home {
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 999;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.menuSmall{
    display: flex;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 4050;
    background: white;
    box-shadow: 0 0 10px 0 rgba(0,0,0,.6);

    .imgLimit{
        padding: vp(25) 0 vp(25) vp(31);
        width: vp(195);
        height: vp(56);

        img{
            width: 100%;
            height: 100%;
        }
    }
    
    // img{
    //     padding: vp(25) 0 vp(25) vp(31);
    //     width: vp(195);
    //     height: vp(56);
    // }

    .menuBo{
        position: absolute;
        top: vp(35);
        right: vp(30);
        width: vp(45);
    }

    span{
        display: flex;
        flex-direction: column;
        width: vp(45);
        height: 3px;
        background: $blue096;

        &:first-of-type,
        &:nth-of-type(2){
            margin-bottom: vp(10);
        }

    }
}
</style>

